/**
 * Checks if an image URL successfully loads and invokes a callback with the result.
 *
 * @param url - The URL of the image to be tested.
 * @param callback - A function to be called with the result of the image load test.
 *                    The callback receives `true` if the image loads successfully,
 *                    and `false` if there is an error loading the image.
 */
export function imageUrlLoads(url: string, callback: (result: boolean) => void): void {
    const img = new Image();
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
    img.src = url;
}
